import {AppBar} from '@material-ui/core'
import React from 'react'

import {Grid, GridProps} from '../../grid'
import {Brand, Lang} from '../../logo/types'
import {classes} from './Header.classes'
import HeaderLogo from './HeaderLogo'
import HideOnScroll from './HideOnScroll'
import Toolbar from './Toolbar'

type Props = GridProps & {
  lang?: Lang
  brand?: Brand
  isExternalLink?: boolean
  // специальный пропс для account2, там рядом с лого есть еще и выбор компании
  showLogo?: boolean
}

// "меню" в хидере пока что вынесено отдельно в account
// потому что в других проектах его пока нет
// нужно согласовать его добавление
const Header: React.FC<React.PropsWithChildren<Props>> = props => {
  const {children, isExternalLink = true, showLogo = true, brand, lang, ...gridProps} = props

  return (
    <HideOnScroll>
      <AppBar classes={classes} color="inherit" elevation={0} position="sticky">
        <Toolbar>
          <Grid alignItems="center" spacing={1} wrap="nowrap" container {...gridProps}>
            {showLogo && (
              <Grid item xs>
                <HeaderLogo brand={brand} isExternalLink={isExternalLink} lang={lang} />
              </Grid>
            )}
            {children}
          </Grid>
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  )
}

export default Header
